let config = null;

export async function loadConfig() {
  if (config) return config;

  // Guard: fetch doesn't exist during Gatsby SSR/build
  if (typeof window === 'undefined') return {};

  const res = await fetch('/config.json');
  config = await res.json();
  return config;
}

export function getConfig() {
  if (!config) throw new Error('Config not loaded. Call loadConfig() first.');
  return config;
}
